/** Shared nav helpers for customer dashboard sidebar + mobile drawer. */

export const normalizePath = (path) => (path || "/").replace(/\/+$/, "") || "/";

export const pathMatches = (pathname, link) => {
  if (!link || link === "/") return false;
  const current = normalizePath(pathname);
  const target = normalizePath(link);
  if (target === "/customer-dashboard/dashboard") return current === target;
  return current === target || current.startsWith(`${target}/`);
};

export const sectionActive = (item, pathname) => {
  if (item.subMenu?.some((sub) => pathMatches(pathname, sub.link))) return true;
  return pathMatches(pathname, item.link);
};
